import { render, staticRenderFns } from "./TestGroup.vue?vue&type=template&id=0e421e8c"
import script from "./TestGroup.vue?vue&type=script&lang=js"
export * from "./TestGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports